import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Relatório Estudantes da Turma',
    path: '/academico/relatorios/turma/estudantes',
    name: 'relatorio-estudantes-turma',
    component: () => import('@/views/academico/relatorios/turma/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PORTURMANOVO_MENU_300800301],
    },
    goesToMenu: true,
  },
  {
    description: 'Configuração Relatório Estudantes da Turma',
    path: '/academico/relatorios/turma/estudantes/configuracao',
    parent: 'relatorio-estudantes-turma',
    name: 'relatorio-estudantes-turma-configuracao',
    component: () => import('@/views/academico/relatorios/turma/Configuracao.vue'),
    meta: {
      permissions: [eTipoPermissao.PORTURMANOVO_MENU_300800301],
    },
  },
];
